import styled from 'styled-components'

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 6rem;
  width: 100%;
  max-width: 144rem;
  margin: 0 auto;
  padding: 0 3rem;
  box-sizing: border-box;
  position: relative;
  min-height: 100vh;
  transition: gap 0.3s ease;

  @media print {
    & {
      display: block;
      width: 100%;
      max-width: none;
      min-height: auto;
      margin: 0;
      padding: 0;
      gap: 0;
    }

    .fab-show-upload,
    .fab-show-results,
    .content-btns-container {
      display: none !important;
    }

    .content-container {
      padding: 0 !important;
    }

    .content-container .values-container {
      width: 100%;
      max-width: none;
      padding: 0 !important;
    }

    .content-container .values-container h2 {
      page-break-after: avoid;
      break-after: avoid-page;
      page-break-inside: avoid;
      break-inside: avoid-page;
    }

    .content-container .values-container > h2:not(:first-of-type) {
      page-break-before: always;
      break-before: page;
    }

    .content-container .values-container .values-file-container,
    .content-container .values-container .values-files-container,
    .content-container .values-container .table-container,
    .content-container .values-container .MuiPaper-root {
      page-break-inside: avoid;
      break-inside: avoid-page;
    }

    .content-container .values-container tr,
    .content-container .values-container td,
    .content-container .values-container th {
      page-break-inside: avoid;
      break-inside: avoid-page;
    }
  }

  &.upload-only {
    gap: 0;
    max-width: 100%;
    align-items: flex-start;
    justify-content: center;

    .files-container {
      width: 80%;
      padding-top: 1.2rem;
      margin: 0 auto;

      .files-upload-panel {
        max-width: 80rem;
      }

      .files-files-container {
        width: 100%;
        max-width: 80rem;
      }

      .files-files-container .PDF-Page {
        width: 100%;
      }

      .files-files-container .PDF-Page > canvas {
        width: 100% !important;
      }
    }
  }

  &.results-only {
    gap: 0;
    max-width: none;
    width: 100%;
    align-items: flex-start;
    justify-content: flex-start;

    .content-container {
      width: 100%;
      flex: 1;
      padding-top: 1.2rem;
    }
  }

  &.compare-mode {
    gap: 3rem;
    max-width: none;
    width: 100%;

    .files-container {
      width: 65%;

      .files-files-container {
        width: 100%;
        max-width: 100%;
      }

      .PDF-Page {
        width: 100%;
      }

      .PDF-Page > canvas {
        width: 100% !important;
      }
    }
  }

  .fab-show-upload {
    position: fixed !important;
    left: 3.2rem !important;
    bottom: 3.2rem !important;
    z-index: 100 !important;
  }

  .fab-show-results {
    position: fixed !important;
    right: 3.2rem !important;
    bottom: 3.2rem !important;
    z-index: 100 !important;
  }

  .PDF-Page > canvas {
    max-width: 100% !important;
    height: auto !important;
  }

  .files-container {
    @media print {
      & {
        display: none !important;
      }
    }

    width: 58%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .files-upload-panel {
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      gap: 2rem;
      width: 100%;
      max-width: 64rem;
      padding: 2.4rem;
      border: 1px solid ${(props) => props.theme.palette.gray[200]};
      border-radius: 12px;
      background: ${(props) => props.theme.palette.contrast};
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
    }

    .upload-panel-header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 1.6rem;
    }

    .upload-panel-title {
      font-size: 2rem;
      font-weight: 700;
      color: ${(props) => props.theme.palette.gray[900]};
      line-height: 1.2;
    }

    .upload-panel-subtitle {
      margin-top: 0.6rem;
      color: ${(props) => props.theme.palette.gray[600]};
      font-size: 1.4rem;
      line-height: 1.8rem;
    }

    .upload-count-chip {
      margin-top: 0.2rem;
      background: ${(props) => props.theme.palette.gray[50]};
      color: ${(props) => props.theme.palette.gray[700]};

      .MuiChip-icon {
        color: ${(props) => props.theme.palette.gray[500]};
      }
    }

    .upload-tabs-container {
      border: 1px solid ${(props) => props.theme.palette.gray[200]};
      border-radius: 10px;
      overflow: hidden;
      background: ${(props) => props.theme.palette.gray[50]};

      .MuiTabs-root {
        min-height: 4.8rem;
        width: 100%;
      }

      .MuiTabs-scroller,
      .MuiTabs-flexContainer {
        width: 100%;
      }

      .MuiTab-root {
        min-height: 4.8rem;
        flex: 1;
        opacity: 1;
        color: ${(props) => props.theme.palette.gray[600]};
        font-size: 1.5rem;
        font-weight: 600;
        text-transform: none;
        letter-spacing: 0;
      }

      .MuiTab-root.Mui-selected {
        color: ${(props) => props.theme.palette.contrast};
        background-color: ${(props) => props.theme.palette.primary};
      }

      .indicator {
        height: 3px;
        background-color: ${(props) => props.theme.palette.primary};
      }
    }

    .upload-actions-container {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .input-file-hidden {
        display: none;
      }

      .upload-actions-main {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 0.8rem;
      }

      .upload-trigger {
        min-width: 24rem;
        height: 4.4rem;
        border-radius: 8px;
        text-transform: none;
        font-size: 1.5rem;
        font-weight: 600;
        padding: 0 1.8rem;
      }

      .upload-actions-hint {
        color: ${(props) => props.theme.palette.gray[500]};
        font-size: 1.2rem;
        margin-left: 0.2rem;
      }

      .MuiButton-outlined {
        border-color: ${(props) => props.theme.palette.gray[300]};
        color: ${(props) => props.theme.palette.gray[800]};
        background: ${(props) => props.theme.palette.contrast};
      }

      .MuiButton-outlined:hover {
        border-color: ${(props) => props.theme.palette.primary};
        background: ${(props) => props.theme.palette.gray[50]};
      }
    }

    .upload-submit-container {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1.2rem;
      margin-top: 1rem;
      .upload-name-input {
        flex: 1;
        max-width: 40rem;
      }

      .MuiButton-contained {
        text-transform: uppercase;
      }
    }

    .files-files-container {
      display: flex;
      flex-direction: column;
      padding-top: 2rem;
      position: relative;
      gap: 1.6rem;

      .file-preview-badge {
        display: inline-flex;
        align-items: center;
        gap: 0.8rem;
        padding: 0.8rem 1.2rem;
        margin-bottom: 1rem;
        width: fit-content;
        background: ${(props) => props.theme.palette.gray[50]};
        color: ${(props) => props.theme.palette.gray[700]};
        border: 1px solid ${(props) => props.theme.palette.gray[200]};
        border-radius: 999px;
        font-size: 1.2rem;

        span {
          max-width: 32rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .img-btn-delete-container {
        position: absolute;
        right: 0;
        margin: 5px;
        opacity: 0.7;
        z-index: 1;
      }
    }

    @media (max-width: 768px) {
      width: 100%;

      .files-upload-panel {
        max-width: 100%;
        padding: 1.8rem;
      }

      .upload-panel-header {
        flex-direction: column;
      }

      .upload-count-chip {
        align-self: flex-start;
      }

      .upload-actions-container {
        .upload-trigger {
          width: 100%;
          min-width: 0;
        }

        .upload-trigger-text {
          font-size: 2.2rem;
        }
      }

      .upload-submit-container {
        flex-direction: column;
        align-items: stretch;

        .upload-name-input {
          max-width: none;
        }
      }

      .files-files-container {
        .file-preview-badge {
          max-width: 100%;
        }
      }
    }
  };

  .content-container {
    @media print {
      & {
        width: 100%;
      }
    }

    flex: 1 1 auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 0;
    width: 100%;
    max-width: 100%;

    .content-btns-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      max-width: 100rem;
      padding: 0 3rem;
    }

    .values-container {
      width: 100%;
      font-size: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 100rem;
      padding: 0 3rem;
    }
  };
`
